import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import NavigateNext from "@material-ui/icons/NavigateNext";
import BreadCumb from "../Department/BreadCumb";
import NotificationDescription from "./ItepDescription";

const list = [
  {
    title: "Notices",
    link: "/itep/notices",
    type: "notifications",
    code: "COLLEGE_ITEP",
  },
];

class ItepComponent extends Component {
  state = {
    link: "",
    code: "",
    title: "",
    year: "",
    isLoaded: false,
  };
  componentDidMount() {
    this.setState({
      isLoaded: false,
    });
    let link = this.props.match.params.link;
    let year = this.props.match.params.year;
    let r = list.filter((el) => el.type == link);
    if (r.length > 0) {
      this.setState({
        link: link,
        year: year,
        code: r[0].code,
        title: r[0].title,
        isLoaded: true,
      });
    } else {
      this.props.history.replace("/");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      this.setState({
        isLoaded: false,
      });
      let link = this.props.match.params.link;
      let year = this.props.match.params.year;
      let r = list.filter((el) => el.type == link);
      if (r.length > 0) {
        this.setState(
          {
            link: link,
            year: year,
            code: r[0].code,
            title: r[0].title,
            isLoaded: false,
          },
          () => this.setState({ isLoaded: true })
        );
      } else {
        this.props.history.replace("/");
      }
    }
  }

  render() {
    return (
      <div>
        <Container>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
              <Card
                style={{
                  boxShadow: "none",
                  background: "",
                  borderRadius: "none",
                }}
              >
                <List component="nav">
                  {list.map((el, index) => (
                    <ListItem
                      button
                      style={{
                        borderBottom: "1px solid #0002",
                        marginBottom: "2px",
                      }}
                      key={index}
                      onClick={() => this.props.history.push(el.link)}
                    >
                      <div
                        style={{
                          fontSize: "1.5em",
                          fontWeight: "300",
                          padding: "0",
                        }}
                      >
                        {el.title}
                      </div>
                    </ListItem>
                  ))}
                </List>
              </Card>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={9}
              lg={9}
              style={{ marginBottom: 20 }}
            >
              {this.state.isLoaded ? (
                <NotificationDescription
                  type={this.state.link}
                  year={this.state.year}
                  code={this.state.code}
                  title={this.state.title}
                  history={this.props.history}
                />
              ) : null}
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default ItepComponent;
